// removed by extract-text-webpack-plugin
module.exports = {"PrintWrap":"Print__PrintWrap___3Vqhn","Pure":"Print__Pure___2U0rc","ButtonPrint":"Print__ButtonPrint___12ixn","PrintPopupContent":"Print__PrintPopupContent___3O95L","popupClose":"Print__popupClose___2WBqc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Print/Print.scss
// module id = 1312
// module chunks = 0